import styled from 'styled-components';
import { S } from './SignUpForm.style';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SignUpSerivce from '../../service/signUp/SignUp';
import UserService from '../../service/User';

const SignUpSNS = () => {
  const [agree, setAgree] = useState<AgreeState>({
    privacy: false,
    service: false,
    location: false,
    info: false,
    marketing: false,
    info_consent: false,
  });
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');
  const [phoneError, setPhoneError] = useState<string | null>(null);
  const [sendSms, setSendSms] = useState(false);
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [verifiedCode, setVerifiedCode] = useState('');
  const [codeError, setCodeError] = useState<string | null>(null);
  const [isButtonActive, setIsButtonActive] = useState(false);
  const [isVerifiedCode, setIsVerifiedCode] = useState(false); // ✅ API 성공 여부 상태
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [socialId, setSocialId] = useState<string | null>(null);
  const [loginType, setLoginType] = useState<string | null>(null);
  const [isNameFixed, setIsNameFixed] = useState(false);
  const [isPhoneFixed, setIsPhoneFixed] = useState(false);

  const [recommendCode, setRecommendCode] = useState('');
  const [isRecommendCodeChecked, setIsRecommendCodeChecked] = useState(false);
  const [recommendCodeValidState, setRecommendCodeValidState] = useState({
    isValid: true,
    text: '',
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('accessToken');
    const email = urlParams.get('email');
    const loginType = urlParams.get('socialLoginType');
    const name = urlParams.get('name');
    const socialId = urlParams.get('socialId');
    const phone = urlParams.get('tel');

    if (!accessToken && !loginType && !socialId && !email) {
      navigate('/login');
      return;
    }

    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
      getUserInfo();
      const currentPath = localStorage.getItem('currentPath') ?? '/';
      localStorage.removeItem('socialLoginType');
      navigate(currentPath);
    } else {
      setLoginType(loginType);
      setSocialId(socialId);
      setEmail(!email || email === 'null' ? '' : String(email));
      setName(!name || name === 'null' ? '' : String(name));
      setPhone(!phone || phone === 'null' ? '' : String(phone));
      setIsNameFixed(!name || name === 'null' ? false : true);
      setIsPhoneFixed(!phone || phone === 'null' ? false : true);

      setTimeout(() => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }, 0);
    }
  }, []);

  const getUserInfo = async () => {
    try {
      const res = await UserService.userInfo();
      localStorage.setItem('userName', res.data.name);
      localStorage.setItem('branchcode', res.data.branchcode);
      localStorage.setItem('department', res.data.department);
      localStorage.setItem('position', res.data.position);
      localStorage.setItem('name', res.data.name);
      localStorage.setItem('email', res.data.email);
      localStorage.setItem('tel', res.data.tel);
      localStorage.setItem('usertype', res.data.usertype);
      localStorage.setItem('state', res.data.state);
      localStorage.setItem('regdate', res.data.regdate);
      localStorage.setItem('notification', res.data.notification);
      localStorage.setItem('login_type', res.data.login_type);
      localStorage.setItem('plan_end', res.data.user.plan_end);
      localStorage.setItem(
        'recommend_code',
        res.data.user.recommend_code ?? '', // null이면 빈 문자열로 저장
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleNameChange = (e: any) => {
    const newName = e.target.value;
    setName(newName);
  };

  const validateRecommendCode = async () => {
    if (!recommendCode) return;

    try {
      const response = await SignUpSerivce.CheckRecommendCode(recommendCode);
      const isValid = response?.data?.isValid;

      if (isValid) {
        setIsRecommendCodeChecked(true);
        setRecommendCodeValidState({
          isValid: true,
          text: '',
        });
      } else {
        setIsRecommendCodeChecked(false);
        setRecommendCodeValidState({
          isValid: false,
          text: '존재하지 않는 추천인 코드입니다.',
        });
      }
    } catch (error: any) {
      setIsRecommendCodeChecked(false);
      setRecommendCodeValidState({
        isValid: false,
        text:
          error?.response?.data?.message ||
          '추천인 코드 확인 중 오류가 발생했습니다.',
      });
    }
  };

  useEffect(() => {
    // 숫자가 포함되어 있으면 에러 메시지 설정
    if (/[0-9]/.test(name)) {
      setNameError('숫자는 허용되지 않습니다.');
    } else {
      setNameError('');
    }
  }, [name]);

  const handlePhoneChange = (e: any) => {
    const value = e.target.value;
    setPhone(value);
    setIsButtonActive(false);
    setIsVerifiedCode(false);
    setIsPhoneValid(false);
    setSendSms(false);
    if (value.length === 0) {
      setPhoneError(null);
      setIsPhoneValid(true);
      return;
    }

    if (!value.startsWith('010')) {
      setPhoneError('휴대폰 형식이 맞지 않습니다.');
      setIsPhoneValid(false);
      return;
    }

    if (value.length !== 11) {
      setPhoneError('휴대폰 번호를 입력하세요.');
      setIsPhoneValid(false);
      return;
    }

    setPhoneError(null);
    setIsPhoneValid(true);
  };

  const handleCodeChange = (e: any) => {
    const value = e.target.value;
    setVerifiedCode(value);
    setIsVerifiedCode(false);
    if (value.length === 0) {
      setCodeError('메시지가 오지 않을 경우 재전송을 눌러주세요.');
      return;
    }

    if (value.length !== 6) {
      setCodeError('인증번호를 6자리 입력해주세요.');
      return;
    }

    if (value.length === 6) {
      setCodeError(null);
      setIsButtonActive(true);
      return;
    }
  };

  useEffect(() => {
    if (phone.length === 0) {
      setPhoneError(null); // 입력값이 없으면 에러 메시지 없음
      setIsPhoneValid(true);
      return;
    }

    if (!phone.startsWith('010')) {
      setPhoneError('휴대폰 형식이 맞지 않습니다.');
      setIsPhoneValid(false);
      return;
    }

    if (phone.length !== 11) {
      setPhoneError('휴대폰 번호를 입력하세요.');
      setIsPhoneValid(false);
      return;
    }

    setPhoneError(null);
    setIsPhoneValid(true);
  }, [phone]);

  const postSms = async () => {
    if (email === '' || phone === '') {
      alert('이메일과 휴대폰 번호를 입력해주세요');
      return;
    }
    try {
      const result = await SignUpSerivce.SendSms({
        type: 'S',
        loginType, //k는 카카오, n은 네이버
        userid: socialId,
        tel: phone,
      });
      if (result.status === 'success') {
        setSendSms(true);
      }
    } catch (error: any) {
      alert(error.response.data.message);
      console.log(error);
    }
  };

  const CheckCode = async () => {
    try {
      const result = await SignUpSerivce.CheckCode({
        type: 'S',
        loginType, //k는 카카오, n은 네이버
        userid: socialId,
        tel: phone,
        authCode: verifiedCode,
      });
      return true;
    } catch (error: any) {
      // alert(error.response.data.message);
      console.log(error);
      return false;
    }
  };

  const handleVerify = async () => {
    if (!isButtonActive) return;

    setCodeError(null); // 기존 에러 메시지 숨김

    const isValid = await CheckCode();
    if (isValid) {
      setCodeError(null);
      setIsVerifiedCode(true);
    } else {
      setIsVerifiedCode(false);
      setCodeError('인증번호가 일치하지 않습니다. 확인 후 재 입력해 주세요.');
    }
  };

  const handleRecommendCodeChange = (e: any) => {
    const value = e.target.value;
    setRecommendCode(value);
  };

  const isRecommendCodeOk = () =>
    recommendCode.trim().length === 0 ||
    (isRecommendCodeChecked && recommendCodeValidState.isValid);

  const isButtonEnabled = () => {
    const isBasicConditionsMet =
      // email &&
      // name &&
      // phone &&
      // isEmailValid &&
      // !emailDuplicateYN &&
      // isEmailCheckYN &&
      // passwordMatch &&
      nameError.length === 0 &&
      phoneError === null &&
      codeError === null &&
      (isPhoneFixed || isVerifiedCode) &&
      agree.privacy &&
      agree.service &&
      agree.location;
    isRecommendCodeOk();

    // usertype이 'b'가 아닐 경우 기본 조건만 체크
    return isBasicConditionsMet;
  };

  const handleNext = async () => {
    if (!agree.privacy || !agree.service || !agree.location) {
      alert('필수 약관에 동의해 주세요.');
      return;
    }

    if (!isRecommendCodeOk()) {
      alert('추천인 코드를 확인해 주세요.');
      return;
    }

    sessionStorage.setItem('name', name);
    SignUpApi();
  };

  const SignUpApi = async () => {
    try {
      const result = await SignUpSerivce.signUp({
        usertype: 'I',
        userid: socialId,
        email: email,
        name: name,
        tel: phone,
        notification: agree.info ? 'Y' : 'N',
        marketing: agree.marketing ? 'Y' : 'N',
        infoConsent: agree.info_consent ? 'Y' : 'N',
        loginType, //k는 카카오, n은 네이버
        code:
          typeof recommendCode === 'string'
            ? recommendCode
            : String(recommendCode),
      });
      if (result.status === 'success') {
        localStorage.removeItem('socialLoginType');
        navigate('/signUpComplete');
      }
    } catch (error: any) {
      alert(error.response.data.message);
      console.log(error);
    }
  };
  return (
    <S.Wrapper>
      <div
        style={{
          padding: '16px',
        }}
      >
        <img
          onClick={() => {
            navigate(-1);
          }}
          src="/assets/images/arrow/back-arrow-left-gray.svg"
        ></img>
      </div>
      <div
        style={[
          {
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column' as 'column',
            gap: 40,
            padding: '40px 16px',
          },
        ].reduce((acc, curr) => Object.assign(acc, curr), {})}
      >
        <div style={styles.contentContainer}>
          <div style={styles.section2}>
            <span style={styles.title}>{`소셜 회원가입`}</span>
            <div style={styles.section2content1}>
              <div style={styles.section2content2}>
                <span style={styles.subTitle}>성명</span>
                <SignupInput
                  isValid={nameError.length === 0}
                  onChange={(e: any) => {
                    handleNameChange(e);
                  }}
                  placeholder="성명을 입력해주세요."
                  value={name}
                  disabled={isNameFixed}
                />
                {nameError.length > 0 && (
                  <S.InputInfoBox isValid={nameError.length === 0}>
                    <img
                      src={`/assets/images/icon/${nameError.length === 0 ? 'signUpInfo_icon' : 'signUpInfo_icon_NotValid'}.svg`}
                    />
                    <span style={styles.errorText}>{nameError}</span>
                  </S.InputInfoBox>
                )}
              </div>
              <div style={styles.section2content2}>
                <span style={styles.subTitle}>휴대폰 번호</span>
                <S.InputBoxWrapper>
                  <S.IdInputBox>
                    <SignupInput
                      isValid={(phoneError?.length ?? 0) === 0}
                      onChange={(e: any) => {
                        handlePhoneChange(e);
                      }}
                      value={phone}
                      placeholder="휴대폰 번호를 입력해주세요."
                      maxLength={11}
                      isavailable={isButtonActive && isVerifiedCode}
                      disabled={isPhoneFixed}
                    />
                    {!isPhoneFixed && (
                      <S.CheckValidButton
                        onClick={
                          isPhoneValid && phone.length > 0
                            ? () => {
                                postSms();
                              }
                            : () => {}
                        }
                        isValid={isPhoneValid && phone.length > 0}
                        sendYN={sendSms}
                        available={isButtonActive && isVerifiedCode}
                        text={
                          isButtonActive && isVerifiedCode
                            ? '인증완료'
                            : sendSms
                              ? '재전송'
                              : '인증번호발송'
                        }
                      >
                        {isButtonActive && isVerifiedCode
                          ? '인증완료'
                          : sendSms
                            ? '재전송'
                            : '인증번호발송'}
                      </S.CheckValidButton>
                    )}
                  </S.IdInputBox>
                  {sendSms && (
                    <S.IdInputBox>
                      <SignupInput
                        isValid={(codeError?.length ?? 0) === 0}
                        onChange={(e: any) => {
                          handleCodeChange(e);
                        }}
                        placeholder="인증번호 6자리를 입력해주세요."
                        maxLength={6}
                        isavailable={isButtonActive && isVerifiedCode}
                      />
                      <S.CheckValidButton
                        onClick={() => {
                          handleVerify();
                        }}
                        available={isButtonActive && isVerifiedCode}
                        isValid={isPhoneValid && phone.length > 0}
                        text={
                          isButtonActive && isVerifiedCode ? '인증완료' : '확인'
                        }
                      >
                        {isButtonActive && isVerifiedCode ? '인증완료' : '확인'}
                      </S.CheckValidButton>
                    </S.IdInputBox>
                  )}
                  {(phoneError?.length ?? 0) > 0 && (
                    <S.InputInfoBox isValid={phoneError?.length === 0}>
                      <img
                        src={`/assets/images/icon/${phoneError?.length === 0 ? 'signUpInfo_icon' : 'signUpInfo_icon_NotValid'}.svg`}
                      />
                      <span style={styles.errorText}>{phoneError}</span>
                    </S.InputInfoBox>
                  )}
                  {(codeError?.length ?? 0) > 0 && (
                    <S.InputInfoBox
                      isValid={
                        codeError?.length === 0 ||
                        (codeError?.includes('재전송') ?? false)
                      }
                    >
                      <img
                        src={`/assets/images/icon/${
                          codeError?.length === 0 ||
                          (codeError?.includes('재전송') ?? false)
                            ? 'signUpInfo_icon'
                            : 'signUpInfo_icon_NotValid'
                        }.svg`}
                      />
                      <span style={styles.errorText}>{codeError}</span>
                    </S.InputInfoBox>
                  )}
                </S.InputBoxWrapper>
              </div>
              <div style={styles.section2content2}>
                <span style={styles.subTitle}>
                  추천인 코드
                  <span style={{ color: 'rgba(55, 56, 60, 0.61)' }}>
                    (선택)
                  </span>
                </span>
                <S.InputBoxWrapper>
                  <S.IdInputBox>
                    <SignupInput
                      isValid={recommendCodeValidState.isValid}
                      value={recommendCode}
                      onChange={(e: any) => {
                        setRecommendCode(e.target.value);
                        setIsRecommendCodeChecked(false);
                        setRecommendCodeValidState({ isValid: true, text: '' });
                      }}
                      isavailable={isRecommendCodeChecked}
                      placeholder="추천인 코드를 입력해주세요."
                    />
                    <S.CheckValidButton
                      onClick={
                        recommendCode.length > 0 && !isRecommendCodeChecked
                          ? validateRecommendCode
                          : () => {}
                      }
                      isValid={recommendCode.length > 0}
                      available={isRecommendCodeChecked}
                    >
                      {isRecommendCodeChecked ? '확인완료' : '확인'}
                    </S.CheckValidButton>
                  </S.IdInputBox>

                  {!isRecommendCodeChecked && recommendCodeValidState.text && (
                    <S.InputInfoBox isValid={recommendCodeValidState.isValid}>
                      <img
                        src={`/assets/images/icon/${
                          recommendCodeValidState.isValid
                            ? 'signUpInfo_icon'
                            : 'signUpInfo_icon_NotValid'
                        }.svg`}
                      />
                      <div>{recommendCodeValidState.text}</div>
                    </S.InputInfoBox>
                  )}
                </S.InputBoxWrapper>
              </div>
            </div>
          </div>

          <div style={styles.section3}>
            <div style={styles.section3content1Wrapper}>
              <div
                style={styles.section3content1}
                onClick={() => {
                  const allAgreed =
                    agree.privacy &&
                    agree.service &&
                    agree.location &&
                    agree.info &&
                    agree.marketing &&
                    agree.info_consent;

                  setAgree({
                    privacy: !allAgreed,
                    service: !allAgreed,
                    location: !allAgreed,
                    info: !allAgreed,
                    marketing: !allAgreed,
                    info_consent: !allAgreed,
                  });
                }}
              >
                <img
                  src={
                    agree.privacy &&
                    agree.service &&
                    agree.location &&
                    agree.info
                      ? '/assets/images/check/signUpcheckOn.svg'
                      : '/assets/images/check/signUpcheckOff.svg'
                  }
                  alt=""
                />
                <span style={styles.section3content1Text}>약관 전체 동의</span>
              </div>
            </div>
            <div style={styles.section3content2Wrapper}>
              {dummy.map((item, index) => {
                const userType = item.state;
                return (
                  <div key={index} style={styles.section3content2}>
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <div
                        style={[
                          {
                            display: 'flex',
                            flexDirection: 'row' as 'row',
                            alignItems: 'center',
                            gap: 12,
                          },
                        ].reduce((acc, curr) => Object.assign(acc, curr), {})}
                      >
                        <img
                          onClick={() => {
                            setAgree({
                              ...agree,
                              [userType]: !agree[userType],
                            });
                          }}
                          src={
                            agree[userType]
                              ? '/assets/images/check/signUpcheckOn.svg'
                              : '/assets/images/check/signUpcheckOff.svg'
                          }
                          alt=""
                        />
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row' as 'row',
                          }}
                        >
                          <span
                            style={{
                              color: item.tag.includes('필수')
                                ? '#008AFF'
                                : '#616161',
                            }}
                          >
                            {item.tag}
                          </span>
                          &nbsp;
                          <span
                            style={[
                              styles.section3content1Text,
                              { fontSize: '14px' },
                            ].reduce(
                              (acc, curr) => Object.assign(acc, curr),
                              {},
                            )}
                          >
                            {item.name}
                          </span>
                        </div>
                      </div>
                      <img
                        onClick={() => {
                          // navigate(item.url);
                          window.open(
                            'https://www.zipgoai.com' + item.url,
                            '_blank',
                          );
                        }}
                        src="/assets/images/arrow/ArrowRightGray.svg"
                        alt=""
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div
          style={[
            styles.nextBtn,
            {
              backgroundColor: isButtonEnabled() ? '#008AFF' : '#F0F0F0',
              cursor: isButtonEnabled() ? 'pointer' : 'null',
            },
          ].reduce((acc, curr) => Object.assign(acc, curr), {})}
          onClick={isButtonEnabled() ? handleNext : () => {}}
          // disabled={!isButtonEnabled()}
        >
          <span
            style={[
              styles.btnText,
              { color: isButtonEnabled() ? '#fff' : '#171E2666' },
            ].reduce((acc, curr) => Object.assign(acc, curr), {})}
          >
            가입하기
          </span>
        </div>
      </div>
    </S.Wrapper>
  );
};

export default SignUpSNS;

type AgreeState = {
  privacy: boolean;
  service: boolean;
  location: boolean;
  info: boolean;
  marketing: boolean;
  info_consent: boolean;
};

type DummyItem = {
  tag: string;
  name: string;
  state: keyof AgreeState;
  url: string;
}[];

const dummy: DummyItem = [
  {
    tag: '[필수]',
    name: '개인정보 처리방침',
    state: 'privacy',
    url: '/terms/privacy',
  },
  {
    tag: '[필수]',
    name: '땅집고 옥션 서비스 이용약관',
    state: 'service',
    url: '/terms/service',
  },
  {
    tag: '[필수]',
    name: '위치기반서비스 이용약관',
    state: 'location',
    url: '/terms/location',
  },
  {
    tag: '[선택]',
    name: '정보 푸시 알림 수신',
    state: 'info',
    url: '/terms/push',
  },
  {
    tag: '[선택]',
    name: '마케팅 수신 동의',
    state: 'marketing',
    url: '/terms/marketing',
  },
  {
    tag: '[선택]',
    name: '제3자 정보 제공 동의',
    state: 'info_consent',
    url: '/terms/info',
  },
];

interface InputBoxProps {
  isValid: boolean;
  isavailable?: boolean;
}

const SignupInput = styled.input<InputBoxProps>`
  border-radius: 8px;
  // border: 1px solid #171e2666;
  // border-color: #171e2666;
  padding-inline: 16px;
  padding-block: 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  line-height: 23.2px;
  text-align: left;
  width: 100%;
  border: none;
  ::placeholder {
    color: #171e2666;
  }
  &:focus {
    outline: none; /* 기본 브라우저 스타일 제거 */
    // border: 1px solid #008aff; /* 보라색 테두리 */

    border: 1px solid ${(props) => (props.isValid ? '#008AFF' : 'red')};
  }

  color: ${(props) =>
    props.isavailable ? 'rgba(55, 56, 60, 0.16);' : '#616161'};
  background-color: ${(props) =>
    props.isavailable ? 'rgba(112, 115, 124, 0.08)' : '#F5F7FA'};
`;

const styles: any = {
  container: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    backgroundColor: '#FFFFFF',
    height: '100%',
    flex: 1,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    width: '100%',
    gap: 48,
  },
  section1: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 32,
  },
  section1content1: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 8,
  },
  section1content2: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: 12,
  },
  title: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '29px',
    textAlign: 'left' as 'left',
  },
  subTitle: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '23.2px',
    textAlign: 'center' as 'center',
  },
  text1: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '18.85px',
    textAlign: 'left' as 'left',
    color: 'rgba(55, 56, 60, 0.61)',
  },
  category: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    paddingBlock: '24px',
    borderRadius: 8,
    border: '1px solid #171E2666',
    flex: 1,
    height: '107px',
  },
  categoryText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '23.2px',
    textAlign: 'left' as 'left',
    color: '#171E2666',
  },
  categoryText2: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '18px',
    fontWeight: '800',
    lineHeight: '26.1px',
    textAlign: 'left' as 'left',
    color: '#171E2666',
  },
  section2: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 48,
  },
  section2content1: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 24,
  },
  section2content2: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 16,
    width: '100%',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    position: 'relative',
  },
  // input: {
  //   borderRadius: 8,
  //   border: '1px solid #171E2666',
  //   borderColor: '#171E2666',
  //   paddingInline: '16px',
  //   paddingBlock: '12px',
  //   fontFamily: 'Spoqa Han Sans Neo',
  //   fontSize: '16px',
  //   fontWeight: '500',
  //   lineHeight: '23.2px',
  //   textAlign: 'left' as 'left',
  //   width: '100%',
  // },
  verfiyWrapper: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    width: '100%',
    justifyContent: 'space-between',
    paddingBlock: '8px',
    paddingRight: '8px',
    paddingLeft: '16px',
    border: '1px solid #171E2666',
    borderColor: '#171E2666',
    borderRadius: 10,
    height: '51px',
  },
  verficationButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black',
    paddingInline: '12px',
    paddingBlock: '6px',
    borderRadius: 8,
    cursor: 'pointer',
  },
  verficationText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '20.3px',
    textAlign: 'left' as 'left',
    color: '#FFFFFF',
  },
  emailWrapper: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    gap: 8,
    width: '100%',
    alignItems: 'center',
  },
  select: {
    width: '100%',
    paddingBlock: '8px',
    paddingRight: '8px',
    paddingLeft: '8px',
    border: '1px solid #171E2666',
    borderColor: '#171E2666',
    borderRadius: 10,
    height: '51px',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '23.2px',
    textAlign: 'left' as 'left',
  },
  pickerWrapper: {
    width: '50%', // pickerWrapper의 너비 설정
  },
  selectplaceholder: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '23.2px',
    textAlign: 'left' as 'left',
    color: '',
  },
  section3: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 32,
  },
  section3content1Wrapper: {
    display: 'flex',
    flexDirection: 'column' as 'column',
    gap: 16,
  },
  section3content1: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-start',
    flexDirection: 'row' as 'row',
    backgroundColor: '#F7F8F9',
    paddingInline: '16px',
    paddingBlock: '12px',
    borderRadius: 8,
    alignItems: 'center',
  },
  section3content1Text: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '24px',

    textAlign: 'left' as 'left',
    color: '#616161',
  },
  section3content2Wrapper: {
    display: 'flex',
    flexDirection: 'column' as 'column',
  },
  section3content2: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingInline: '16px',
    paddingBlock: '12px',
    cursor: 'pointer',
  },
  nextBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingInline: '16px',
    paddingBlock: '14px',
    backgroundColor: '#F0F0F0',
    width: '100%',
    borderRadius: 8,
  },
  btnText: {
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '26.1px',
    textAlign: 'left' as 'left',
    color: '#171E2666',
  },
  errorText: {
    color: 'red',
    fontFamily: 'Spoqa Han Sans Neo',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '20.30px',
    wordWrap: 'break-word',
  },
};
